"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _src = require("@seedlang/utils/src");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var InterjectionCardWrapper = function InterjectionCardWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    // also in review_deck_options_wrapper.js

    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "filteredCardCount", _descriptor, _this);
      _state.DeckUI.enrichSentence(_this.props.card);
      if (props.card.isLastCard && props.inView) {
        _this.whenLastCard();
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.card.isLastCard && !prevProps.inView && this.props.inView) {
          this.whenLastCard();
        }
      }
    }, {
      key: "showWordCard",
      get: function get() {
        return this.props.inView && this.props.card && this.props.card.sentence && this.props.card.sentence.state.selectedWordAssociationId;
      }
    }, {
      key: "hasActiveFilters",
      get: function get() {
        var deck = _state.DeckUI.deck;
        return (0, _src.isPresent)(deck.reviewsFilterCardTypeId) || deck.reviewsFilterRetired !== null || (0, _src.isPresent)(deck.reviewsFilterDifficultyLabel) || (0, _src.isPresent)(deck.reviewsFilterCreatedAtDaysAgo) || (0, _src.isPresent)(deck.reviewsFilterDue);
      }
    }, {
      key: "showMoreReviewsButton",
      get: function get() {
        if (!_state.DeckUI.reviewDeck) return false;

        // Check if filters would result in zero cards
        if (this.hasActiveFilters && this.filteredCardCount === 0) {
          return false;
        }
        return _state.DeckUI.deck.pastDueCount !== 0;
      }
    }, {
      key: "whenLastCard",
      value: function whenLastCard() {
        _state.AppUI.soundEffectStore.play('tada');
        this.getPastDueCount();
        if (this.hasActiveFilters) {
          this.getFilteredCardCount();
        }
      }
    }, {
      key: "getPastDueCount",
      value: function getPastDueCount() {
        _state.DeckUI.deckStore.pastDueCount({
          ids: {
            deckId: _state.DeckUI.deck.id
          }
        }, this.afterGetPastDueCount);
      }
    }, {
      key: "afterGetPastDueCount",
      value: function afterGetPastDueCount(resp) {
        if (_state.DeckUI.deck && _state.DeckUI.deck.setPastDueCount) {
          _state.DeckUI.deck.setPastDueCount(resp.pastDueCount);
        }
      }

      // also in review_deck_options_wrapper.js
    }, {
      key: "getFilteredCardCount",
      value: function getFilteredCardCount() {
        var deck = _state.DeckUI.deck;
        var filters = {
          card_type_id: deck.reviewsFilterCardTypeId,
          retired: deck.reviewsFilterRetired,
          difficulty_label: deck.reviewsFilterDifficultyLabel,
          created_at_before_after: deck.reviewsFilterCreatedAtBeforeAfter,
          created_at_days_ago: deck.reviewsFilterCreatedAtDaysAgo,
          due: deck.reviewsFilterDue
        };
        _state.AppUI.deckStore.cardsCount({
          ids: {
            deckId: deck.id
          },
          data: {
            filters: filters
          }
        }, this.afterGetFilteredCardCount);
      }
    }, {
      key: "afterGetFilteredCardCount",
      value: function afterGetFilteredCardCount(resp) {
        this.filteredCardCount = resp.count;
      }
    }, {
      key: "moreReviewsButtonCount",
      get: function get() {
        var remainingCount = _state.DeckUI.deck.useDailyGoal && (0, _src.isPresent)(_state.DeckUI.deck.dailyGoal) ? _state.DeckUI.deck.remainingDailyGoal : _state.DeckUI.deck.pastDueCount;
        if (this.hasActiveFilters) {
          return Math.min(remainingCount, this.filteredCardCount);
        }
        return remainingCount;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showWordCard: this.showWordCard,
          showMoreReviewsButton: this.showMoreReviewsButton,
          moreReviewsButtonCount: this.moreReviewsButtonCount
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "filteredCardCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "showWordCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showWordCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasActiveFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasActiveFilters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showMoreReviewsButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showMoreReviewsButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "whenLastCard", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "whenLastCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getPastDueCount", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getPastDueCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetPastDueCount", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetPastDueCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getFilteredCardCount", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getFilteredCardCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetFilteredCardCount", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetFilteredCardCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "moreReviewsButtonCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "moreReviewsButtonCount"), _class2.prototype), _class2)) || _class;
};
InterjectionCardWrapper.displayName = 'InterjectionCardWrapper';
var _default = exports["default"] = InterjectionCardWrapper;